var React = require('react');

function IcLocation (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"ic-location","d":"M5 0C1.533 0-.622 3.889 1.112 7L5 14l3.888-7C10.622 3.889 8.467 0 5 0zm0 7C3.579 7 2.423 5.8 2.423 4.326S3.58 1.653 5 1.653s2.577 1.199 2.577 2.673C7.577 5.801 6.42 7 5 7z"})),React.createElement("use",{"fill":"#5d7186","fillRule":"evenodd","transform":"translate(3 1)","xlinkHref":"#ic-location","key":1})]);
}

IcLocation.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IcLocation;

IcLocation.default = IcLocation;
